
  import createMeisterIcons from '../src/createMeisterIcons';

  const CurvedRectangle = createMeisterIcons("curved-rectangle", [["path",{"fill":"currentColor","d":"M9 3.75A3.26 3.26 0 0 0 5.75 7v10A3.26 3.26 0 0 0 9 20.25h6A3.26 3.26 0 0 0 18.25 17V7A3.26 3.26 0 0 0 15 3.75zM4.25 7A4.76 4.76 0 0 1 9 2.25h6A4.76 4.76 0 0 1 19.75 7v10A4.76 4.76 0 0 1 15 21.75H9A4.76 4.76 0 0 1 4.25 17z","key":"5ed25a7e114fbcc460ba019986e19f371509bb84","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default CurvedRectangle
  